import { Link } from 'react-router-dom';

const columns = [
  { label: 'Potência', bt800: '800W / 220V', bt950: '2100W / 220V' },
  { label: 'Velocidade de Solda', bt800: '2–5 m/min', bt950: '5–8 m/min' },
  { label: 'Temperatura Máx.', bt800: '400°C', bt950: '500°C' },
  { label: 'Espessura do Material', bt800: '500–1500 mic', bt950: '500–3000 mic' },
  { label: 'Peso', bt800: '4,5 kg', bt950: '11 kg' },
  { label: 'Largura de Solda', bt800: '30 mm', bt950: '40 mm' },
  { label: 'Garantia', bt800: '12 meses', bt950: '6 meses' },
  { label: 'Tensão', bt800: '220V / 50-60Hz', bt950: '220V / 50-60Hz' },
];

export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-green-600 text-xs font-black uppercase tracking-[0.2em]">
            Comparativo Técnico
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 uppercase mt-3 mb-4">
            Compare os Modelos
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto leading-relaxed">
            Comparação técnica entre os modelos de cunha quente da linha SoldaGeo.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-gray-200">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-900 text-white">
                <th className="px-5 py-4 text-xs font-black uppercase tracking-wider w-1/3">
                  Especificação
                </th>
                <th className="px-5 py-4 text-center text-xs font-black uppercase tracking-wider">
                  <Link to="/produto/bt800" className="hover:text-green-400 transition-colors cursor-pointer">
                    BT800
                  </Link>
                </th>
                <th className="px-5 py-4 text-center text-xs font-black uppercase tracking-wider">
                  <Link to="/produto/bt950" className="hover:text-green-400 transition-colors cursor-pointer">
                    BT950
                  </Link>
                </th>
              </tr>
            </thead>
            <tbody>
              {columns.map((row, idx) => (
                <tr
                  key={row.label}
                  className={`border-t border-gray-100 ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/70'}`}
                >
                  <td className="px-5 py-3.5 text-xs font-black text-gray-700 uppercase tracking-wide">
                    {row.label}
                  </td>
                  <td className="px-5 py-3.5 text-center text-sm text-gray-600">{row.bt800}</td>
                  <td className="px-5 py-3.5 text-center text-sm text-gray-600">{row.bt950}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-gray-400 text-xs mt-4 text-center">
          As especificações acima são baseadas nos dados técnicos oficiais de cada modelo. Consulte a página do produto para informações completas.
        </p>
      </div>
    </section>
  );
}